export default __webpack_public_path__ + "static/3-7da347df52bb2e57e4f04a993e2692da.jpg";